import { useSelector } from 'react-redux';

import type { RootState } from '../../../../store';

export default function useOnboardingQuestionnaireUpdateLoading() {
  return useSelector(
    (state: RootState) => state.onboardingQuestionnaire.updateGeneralInfoLoading,
  );
}
